/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Popover/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Popover({
  children,
  viewPath = "/DesignSystem/Popover",
  parentRef,
  onMouseEnter,
  onMouseLeave,
  flexGrow,
  flexShrink,
  flexBasis,
  focused,
  disabled,
  hovered,
  closePopover,
  top,
  left,
  width,
  contentRef,
  triggerRef,
  onLeftClick,
  onRightClick,
  isOpen,
  isLeftClickOpen,
  isRightClickOpen,
  isHoverOpen,
  onKeyUp,
  onFocus,
  onBlur
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Popover.Vertical"
  data-view-path={viewPath}
 ref={parentRef}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--fg-1-1uKzif': flexGrow,'--fs-2-1uKzif': flexShrink,'--fb-3-1uKzif': typeof flexBasis === 'number' ? `${flexBasis}%` : flexBasis}}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 focused={focused}
 disabled={disabled}
 hovered={hovered}
 closePopover={closePopover}
 top={top}
 left={left}
 width={width}
 contentRef={contentRef}
 triggerRef={triggerRef}
 onLeftClick={onLeftClick}
 onRightClick={onRightClick}
 isOpen={isOpen}
 isLeftClickOpen={isLeftClickOpen}
 isRightClickOpen={isRightClickOpen}
 isHoverOpen={isHoverOpen}
 onKeyUp={onKeyUp}
 onFocus={onFocus}
 onBlur={onBlur}
>
{children}
</Children>
</div>
</React.Fragment>)
}